import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-userCenter8",
  "use": "icon-userCenter8-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-userCenter8\"><g fill=\"none\" fill-rule=\"nonzero\"><path d=\"M22 3.5c8.64 0 15.643 7.004 15.643 15.643V35.5H6.357V19.143C6.357 10.503 13.361 3.5 22 3.5zm12.643 29V19.143C34.643 12.16 28.983 6.5 22 6.5c-6.982 0-12.643 5.66-12.643 12.643V32.5h25.286z\" fill=\"#001837\" /><path fill=\"#001837\" d=\"M23.5 1.01h-3V6.5h3zM2.232 32.5v3h39.536v-3z\" /><path fill=\"#2F54EB\" d=\"M14 39v4h16v-4z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol